import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle } from "react-native-svg";

export const IconControllerButtonCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconControllerButtonCircle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Circle cx="12" cy="12" r="5" stroke="currentColor"/></CentralIconBase>;
});

export default IconControllerButtonCircle;
